
import React from 'react';
import {deep_copy} from "../../../lib/js-utils";


const dump_button = (button, style_, current, on_click, component) => {

  const style = deep_copy(style_);
  style.border = "solid black 1px";
  if (current === button.id) {
    style.background = "#666";
    style.color = "#FFF";
  }
  if (button.style) {
    Object.assign(style, button.style);
  }

  const local_click = () => {
    on_click(button.id);
  }

  const on_enter = (enter) => () => {
    if (enter) {
      component.setState({
        button_select_over: button.id,
      })
    } else {
      component.setState({
        button_select_over: null,
      });
    }
  }
  return (
    <div
      style={style}
      align={"center"}
      onMouseEnter={on_enter(true)}
      onMouseLeave={on_enter(false)}
      onClick={local_click} key={button.id}>
      { button.label }
    </div>
  );
}

const TableButtons = props => {
  const button_list = props.button_list;
  const button_style = props.button_style;
  const component = props.component;

  const container_style = {
    display: "flex",
  }

  return (
    <div style={container_style}>
      { button_list.map(
        button => dump_button(button, button_style, props.current,
        props.on_click, component))}
    </div>
  )
}

export { TableButtons };
